import React from "react";
import { ReactComponent as Logo } from "../../assets/logo.svg";
import styles from "./Loader.module.css";

const Loader = () => {
  return (
    <div className={styles.container}>
      <Logo />
    </div>
  );
};

export default Loader;
